/**
 * External dependencies
 */
import { Page } from '@web-stories-wp/story-editor/src/elements/types';
/**
 * Internal dependencies
 */
import { isEqual } from './isEqual';

export function wasPageChanged(originalPage: Page, newPage: Page) {
  const keysToIgnore = ['isChanged', 'isDefaultBlankPage'];

  // If the page already exists in the CMS, then the visibility was updated with its own API call
  // (search for 'togglePageHidden'), so we don't need to save those changes
  if (newPage.cmsPageId) {
    keysToIgnore.push('hidden');
  }

  return !isEqual(originalPage, newPage, keysToIgnore);
}
